function applyDatepickerComponent($element) {
  $element
    .mask('99/99/9999')
    .datepicker({
      language: 'pt-BR',
      autoclose: true,
      format: 'dd/mm/yyyy',
    });
}

export default applyDatepickerComponent;
